import { createContext, useState } from "react";
import React from "react";

export const UrlContext = createContext();

export const UrlProvider = ({ children }) => {
  let API_URL;
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    API_URL = "https://test.expertpowerhouse.com/api/";
  } else if (process.env.REACT_APP_ENVIRONMENT === "production") {
    API_URL = "https://tool.expertpowerhouse.com/api/";
  } else {
    API_URL = "http://localhost:5001/api/";
  }
  let URI;
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    URI = "https://test.expertpowerhouse.com/";
  } else if (process.env.REACT_APP_ENVIRONMENT === "production") {
    URI = "https://tool.expertpowerhouse.com/";
  } else {
    URI = "http://localhost:3000/";
  }
  console.log(API_URL);
  return (
    <UrlContext.Provider value={{ API_URL, URI }}>
      {children}
    </UrlContext.Provider>
  );
};
